/**
 * 减号图标
 */
const MinusIcon = ({ width = 18, height = 2, color = '#BBBBBD' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 2" fill="none">
      <rect x="0.666626" y="0.167969" width="16.6667" height="1.66667" fill={color} />
    </svg>
  )
}

export default MinusIcon
